export default "__VITE_ASSET__58SHbOVG__"